const DEFAULT_PUBLIC_BASE_HOSTS = [
  "mkr.click",
  "alpha.makermarket.com",
  "app.makermarket.com",
];

function getConfiguredBaseHosts() {
  const rawHosts = [
    process.env.VUE_APP_MAKER_LINK_PUBLIC_BASE_HOST,
    process.env.VUE_APP_MAKER_LINK_PUBLIC_BASE_HOSTS,
  ]
    .filter(Boolean)
    .join(",");

  const hosts = rawHosts
    .split(",")
    .map((host) => normalizeHostname(host))
    .filter(Boolean);

  return [...new Set([...hosts, ...DEFAULT_PUBLIC_BASE_HOSTS])];
}

function normalizeHostname(hostname) {
  return String(hostname || "")
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .split("/")[0]
    .split(":")[0]
    .trim();
}

function getCurrentHostname() {
  if (typeof window === "undefined") return "";
  return normalizeHostname(window.location.hostname);
}

export function getMakerLinkBaseHost(hostname = getCurrentHostname()) {
  const normalizedHostname = normalizeHostname(hostname);

  return getConfiguredBaseHosts()
    .sort((first, second) => second.length - first.length)
    .find((baseHost) => {
      return (
        normalizedHostname === baseHost ||
        normalizedHostname.endsWith(`.${baseHost}`)
      );
    });
}

export function getMakerLinkSubdomainIdentifier(
  hostname = getCurrentHostname(),
) {
  const normalizedHostname = normalizeHostname(hostname);
  const baseHost = getMakerLinkBaseHost(normalizedHostname);

  if (!baseHost || normalizedHostname === baseHost) return "";

  const prefix = normalizedHostname.slice(0, -(baseHost.length + 1));

  if (!prefix || prefix === "www" || prefix.includes(".")) return "";
  if (!/^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/.test(prefix)) return "";

  return prefix;
}

export function formatMakerLinkPublicUrl(slug) {
  const normalizedSlug = String(slug || "")
    .trim()
    .toLowerCase();
  const baseHost = getMakerLinkBaseHost() || DEFAULT_PUBLIC_BASE_HOSTS[0];

  if (!normalizedSlug) return "";

  return `https://${normalizedSlug}.${baseHost}`;
}

export function getMainAppUrl(path = "") {
  const baseHost = getMakerLinkBaseHost();
  const protocol =
    typeof window !== "undefined" ? window.location.protocol : "https:";
  const fallbackOrigin =
    typeof window !== "undefined" ? window.location.origin : "";
  const origin = baseHost ? `${protocol}//${baseHost}` : fallbackOrigin;
  const normalizedPath = String(path || "");

  if (!normalizedPath) return origin;

  return `${origin}${
    normalizedPath.startsWith("/") ? "" : "/"
  }${normalizedPath}`;
}
